import Flickity from 'flickity';

const options = {
  cellAlign: 'right',
  wrapAround: true,
  watchCSS: true, // Flickity should be manually set with CSS, @see https://flickity.metafizzy.co/options#watchcss
  setGallerySize: false, // Avoid height resizing
  lazyLoad: 1,
};

function handleCarouselNavigation(HTMLCarousel, flickity) {
  if (!HTMLCarousel) {
    return;
  }

  HTMLCarousel
    .querySelector('.flickity-prev-next-button.next')
    .addEventListener('click', (event) => {
      flickity.reposition();
      event.preventDefault();
      event.stopImmediatePropagation();
    });

  HTMLCarousel
    .querySelector('.flickity-prev-next-button.previous')
    .addEventListener('click', (event) => {
      flickity.reposition();
      event.preventDefault();
      event.stopImmediatePropagation();
    });
}

const flickitys = [];

function initCarouselRegulars() {
  const carouselRegulars = document.querySelectorAll('.carousel--regular');

  carouselRegulars.forEach((carouselRegular) => {
    // eslint-disable-next-line no-new
    const regularFlickity = new Flickity(carouselRegular, options);

    const dataCarousel = carouselRegular.getAttribute('data-carousel');

    if (dataCarousel) {
      const carouselOptions = JSON.parse(dataCarousel);

      if (carouselOptions.viewport?.height) {
        // eslint-disable-next-line no-param-reassign
        carouselRegular.querySelector('.flickity-viewport').style.height = carouselOptions.viewport.height;
      }

      if (carouselOptions.viewport?.width) {
        // eslint-disable-next-line no-param-reassign
        carouselRegular.querySelector('.flickity-viewport').style.width = carouselOptions.viewport.width;
      }
    }

    handleCarouselNavigation(carouselRegular, regularFlickity);
  });
}

function addCustomMargin(flickity, domElement) {
  const slides = domElement.querySelector('.flickity-page-dots');

  if (slides?.children.length) {
    const slidesNumber = slides.children.length;
    let hasCustomMargin = false;
    flickity.on('select', (index) => {
      if (slidesNumber - 1 !== index && hasCustomMargin) {
        // eslint-disable-next-line no-param-reassign
        domElement.querySelector('.flickity-slider').style.marginLeft = '4px';
        hasCustomMargin = false;
      }

      if (slidesNumber - 1 === index) {
        // eslint-disable-next-line no-param-reassign
        domElement.querySelector('.flickity-slider').style.marginLeft = '-4px';
        hasCustomMargin = true;
      }
    });
  }
}

function initCarouselOuter() {
  const carouselOuter = document.querySelector('.carousel--outer');
  if (carouselOuter) {
    const noWrapOption = document.querySelector('.carousel--no-wrap');

    if (noWrapOption) {
      options.wrapAround = false;
      options.contain = true;
      options.groupCells = true;
    }

    // eslint-disable-next-line no-new
    const flickityOuter = new Flickity('.carousel--outer', { ...options, lazyLoad: false });

    if (noWrapOption) {
      addCustomMargin(flickityOuter, carouselOuter);
    }

    const innerOptions = {
      draggable: false,
      ...options,
    };
    document.querySelectorAll('.carousel--inner').forEach((carousel) => {
      // eslint-disable-next-line no-new
      new Flickity(carousel, innerOptions);
      // eslint-disable-next-line no-param-reassign
      carousel.querySelector('.flickity-viewport').style.height = '220px';
      // eslint-disable-next-line no-param-reassign
      carousel.querySelector('.flickity-slider').style.transition = 'transform 0.3s ease';
    });
  }
}

function initCarouselInner() {
  const carouselsInner = document.querySelectorAll('.carousel--inner');
  if (carouselsInner.length) {
    const innerOptions = {
      draggable: false,
      ...options,
    };
    carouselsInner.forEach((carousel) => {
      const flickity = new Flickity(carousel, innerOptions);

      flickity.resize();
      flickity.reposition();

      // eslint-disable-next-line no-param-reassign
      carousel.querySelector('.flickity-viewport').style.height = '220px';
      // eslint-disable-next-line no-param-reassign
      carousel.querySelector('.flickity-slider').style.transition = 'transform 0.3s ease';

      handleCarouselNavigation(carousel, flickity);
      flickitys.push(flickity);
    });

    const container = document.querySelector('.cards-wrapper');
    container.addEventListener('scroll', () => {
      flickitys.forEach((flickity) => {
        flickity.resize();
        flickity.reposition();
      });
    });

    const activeCarouselOuter = document.querySelector('.carousel--outer.flickity-enabled');
    if (activeCarouselOuter) {
      activeCarouselOuter.querySelector('.flickity-viewport').style.height = '360px';
    }
  }
}

export const initCarousel = () => {
  if (document.querySelector('.carousel')) {
    initCarouselRegulars();
    initCarouselOuter();
    initCarouselInner();
  }
};

export const refreshFlickitys = (flickityGUIDS = []) => {
  let flickitysToUpdate = flickitys;

  if (!flickityGUIDS.length) {
    flickitysToUpdate = flickitys
      .filter((flickity) => flickityGUIDS.includes(flickity.guid));
  }

  flickitysToUpdate.forEach((flickity) => flickity.resize());
};
